(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/utils/api-calls.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/utils/api-calls.js');
"use strict";



const locationNamePath = _ref => {
  let lat = _ref.lat,
    lng = _ref.lng;
  return "".concat(svs.lyckoplatsen.data.config.apiLocation, "/v1/reverse?latitude=").concat(lat, "&longitude=").concat(lng);
};
setGlobal('svs.lyckoplatsen.shared_map.utils', {
  fetchLocationName: async location => {
    try {
      let data;
      if (svs.lyckoplatsen.data.config.apiLocation.includes('open')) {
        data = await fetch(locationNamePath(location));
      } else {
        data = await fetch(locationNamePath(location), {
          headers: {
            'x-jwt-token': "".concat(svs.lyckoplatsen.data.config.jwt)
          }
        });
      }
      const json = await data.json();
      if (json === undefined) {
        throw new Error('Fetched data is undefined');
      }
      return json;
    } catch (error) {
      svs.lyckoplatsen.logger.error('Failed to fetch location name', error);
    }
  },
  fetchNaborTiles: async () => {
    try {
    } catch (error) {
      svs.lyckoplatsen.logger.error('Failed to fetch xxx ', error);
    }
  }
});

 })(window);